export var StringMatchType;
(function (StringMatchType) {
    StringMatchType[StringMatchType["Equals"] = 0] = "Equals";
    StringMatchType[StringMatchType["DoesNotEqual"] = 1] = "DoesNotEqual";
    StringMatchType[StringMatchType["Contains"] = 2] = "Contains";
    StringMatchType[StringMatchType["IsNotEmpty"] = 3] = "IsNotEmpty";
    StringMatchType[StringMatchType["IsEmpty"] = 4] = "IsEmpty";
    StringMatchType[StringMatchType["StartsWith"] = 5] = "StartsWith";
    StringMatchType[StringMatchType["EndsWith"] = 6] = "EndsWith";
    StringMatchType[StringMatchType["DoesNotContain"] = 7] = "DoesNotContain";
    StringMatchType[StringMatchType["DoesNotEndWith"] = 8] = "DoesNotEndWith";
    StringMatchType[StringMatchType["DoesNotStartWith"] = 9] = "DoesNotStartWith";
})(StringMatchType || (StringMatchType = {}));
;
